import { Component } from "../extends";

export default () =>
	class Youtube extends Component() {
		events() {
			this.overlay.addEventListener("click", () => this.playVideo());
		}

		mounted() {
			this.overlay = this.el.querySelector(".c-youtube__poster");
			this.video = this.el.querySelector(".c-youtube__content");
			this.player = null;
			this.videoId = this.video.getAttribute("data-youtube-id");

			// init video
			this.initVideo();
		}

		initVideo() {
			window.YT.ready(() => {
				const player = new YT.Player(this.video.id, {
					height: "320",
					width: "320",
					videoId: this.videoId,
					playerVars: {
						autoplay: 0,
						rel: 0,
						fs: 0,
						showinfo: 0,
						modestbranding: 1,
					},
				});

				this.player = player;
			});
		}

		playVideo() {
			// Hide overlay
			this.el.classList.add("is-active");

			// Play video
			this.player.playVideo();
		}
	};
